import { CategoryDto } from "../category/category.dto";

export class ContactTypeDto extends CategoryDto {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact-type/contact-type.dto.ts